/* Couture Fashion Show look panel (sections/cfs-look-panel.liquid).
   Sales state + countdown, version switch (with / without cap, no reload) and waiting-list dialog.
   Config comes from data attributes on each .cfs-pdp root; safe for several instances. */
(function () {
  if (window.cfsLook) return;
  var roots = [];

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function q(r, sel) { return r.querySelector(sel); }

  function setTimer(t, left) {
    if (!t.d) return;
    t.d.textContent = pad(Math.floor(left / 86400));
    t.h.textContent = pad(Math.floor((left % 86400) / 3600));
    t.m.textContent = pad(Math.floor((left % 3600) / 60));
    t.s.textContent = pad(left % 60);
  }

  // State per root: pre (countdown to launch), live (countdown to the close), post (closed). Every second.
  function tick() {
    var now = Date.now();
    var buy = false;
    roots = roots.filter(function (r) { return r.isConnected; });
    roots.forEach(function (r) {
      var start = Date.parse(r.getAttribute('data-cfs-launch'));
      var end = Date.parse(r.getAttribute('data-cfs-end'));
      if (!isNaN(start) && !isNaN(end)) {
        var state = now < start ? 'pre' : (now > end ? 'post' : 'live');
        r.setAttribute('data-cfs-state', state);
        if (state === 'pre') setTimer(r.cfsTimer, Math.floor((start - now) / 1000));
        else if (state === 'live') setTimer(r.cfsLive, Math.floor((end - now) / 1000));
      }
      if (r.getAttribute('data-cfs-state') === 'live' && r.getAttribute('data-cfs-sold') === 'false') buy = true;
    });
    if (buy) document.documentElement.setAttribute('data-cfs-buy', 'on');
    else document.documentElement.removeAttribute('data-cfs-buy');
  }

  // Switch to version k ("cap" / "base"). user = true for a click (updates URL and gallery).
  function pick(r, k, user) {
    var card = q(r, '[data-cfs-pick="' + k + '"]');
    if (!card || r.getAttribute('data-cfs-current') === k) return;
    var url = (card.getAttribute('data-url') || '').split('?')[0];
    var title = card.getAttribute('data-title') || '';
    var media = card.getAttribute('data-media');

    r.setAttribute('data-cfs-current', k);
    r.setAttribute('data-cfs-sold', card.getAttribute('data-available') === 'true' ? 'false' : 'true');
    r.querySelectorAll('[data-cfs-pick]').forEach(function (c) {
      var on = c === card;
      c.setAttribute('aria-checked', on ? 'true' : 'false');
      c.tabIndex = on ? 0 : -1;
    });

    if (user && url) {
      try { history.replaceState(history.state, '', url + location.search + location.hash); } catch (e) {}
      var thumb = media && document.querySelector('[data-thumbnail-id="' + media + '"]');
      if (thumb) thumb.click();
    }

    // Waiting list: send the version being viewed.
    var f = q(r, '[data-cfs-f="product"]');
    if (f) f.value = title;
    f = q(r, '[data-cfs-f="link"]');
    if (f && url) f.value = (r.getAttribute('data-cfs-shop') || location.origin) + url;
    f = q(r, '[data-cfs-f="body"]');
    if (f) f.value = (f.getAttribute('data-prefix') || '') + title;
    f = q(r, '[data-cfs-wl-title]');
    if (f) f.textContent = title;

    tick();
  }

  function openDialog(d) {
    if (d && typeof d.showModal === 'function' && !d.open) d.showModal();
  }

  // #waitlist in the URL opens the first panel's waiting list.
  function openFromHash() {
    if (location.hash !== '#waitlist') return;
    for (var i = 0; i < roots.length; i++) {
      var d = q(roots[i], 'dialog.cfs-dialog');
      if (d) return openDialog(d);
    }
  }

  function setup(r) {
    if (r.cfsReady) return;
    r.cfsReady = true;
    roots.push(r);
    r.cfsTimer = { d: q(r, '[data-cfs-d]'), h: q(r, '[data-cfs-h]'), m: q(r, '[data-cfs-m]'), s: q(r, '[data-cfs-s]') };
    r.cfsLive = { d: q(r, '[data-cfs-ld]'), h: q(r, '[data-cfs-lh]'), m: q(r, '[data-cfs-lm]'), s: q(r, '[data-cfs-ls]') };
    var dialog = q(r, 'dialog.cfs-dialog');
        // Shopify's hCaptcha puzzle opens outside the pop-up: close the pop-up on submit so the puzzle can be clicked.
    var wlForm = dialog && q(dialog, 'form');
    if (wlForm) wlForm.addEventListener('submit', function () { dialog.close(); });


    r.addEventListener('click', function (e) {
      var t = e.target;
      var card = t.closest('[data-cfs-pick]');
      if (card) return pick(r, card.getAttribute('data-cfs-pick'), true);
      if (t.closest('[data-cfs-waitlist-open]')) return openDialog(dialog);
      if (dialog && dialog.open && (t === dialog || t.closest('[data-cfs-waitlist-close]'))) dialog.close();
    });

    // Radio group keyboard support: arrows move and select.
    r.addEventListener('keydown', function (e) {
      var dir = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      var card = dir && e.target.closest('[data-cfs-pick]');
      if (!card) return;
      var cards = Array.prototype.slice.call(r.querySelectorAll('[data-cfs-pick]'));
      var next = cards[(cards.indexOf(card) + dir + cards.length) % cards.length];
      e.preventDefault();
      next.focus();
      pick(r, next.getAttribute('data-cfs-pick'), true);
    });

    // Reopen after a contact form post (success or errors).
    if (dialog && q(dialog, '[data-cfs-posted], .cfs-dialog__errors')) openDialog(dialog);
  }

  function init() {
    document.querySelectorAll('.cfs-pdp').forEach(setup);
    tick();
    openFromHash();
  }

  window.cfsLook = { init: init };
  init();
  setInterval(tick, 1000);
  window.addEventListener('hashchange', openFromHash);
  document.addEventListener('shopify:section:load', init);
})();